/**
 * @generated SignedSource<<9524e67479121c148f961069b31686ca>>
 * @relayHash e9e91bdc41c6aa27ad4d602068d16895
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0e336d258a380543df462bd3a25cb41dfa6293e9221f871efa9346b76c8fabd9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { hubHomeContentWrapperQuery } from './hubHomeContentWrapperQuery.graphql';

const node: PreloadableConcreteRequest<hubHomeContentWrapperQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0e336d258a380543df462bd3a25cb41dfa6293e9221f871efa9346b76c8fabd9",
    "metadata": {},
    "name": "hubHomeContentWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
